import { render, staticRenderFns } from "./TransactionCDDFlag.vue?vue&type=template&id=ccda9d42"
import script from "./TransactionCDDFlag.vue?vue&type=script&lang=js"
export * from "./TransactionCDDFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports